import React, { useEffect } from 'react'
import { COPY_STRINGS } from '../../../../constants/translatedCopy'

export default function ASRIntroduction(props) {

    const { speechProps, goToNextState, teacherMode } = props

    useEffect(() => {
        runSpeech()
    }, [])

    const runSpeech = async () => {
        if(teacherMode){
            await speechProps.speakWithPromise({ textToSpeak: COPY_STRINGS.student_checks.teacher_mode_asr_initial_prompt_one })
            await speechProps.speakWithPromise({ textToSpeak: COPY_STRINGS.student_checks.teacher_mode_asr_initial_prompt_two })
        }else{
            await speechProps.speakWithPromise({ textToSpeak: COPY_STRINGS.student_checks.student_asr_initial_prompt })
        }
        goToNextState()
    }

    return null
}
